import { AssessmentOverviewFormField } from '../sections/AssessmentOverview/formField'
import { PatientOverviewFormField } from '../sections/PatientOverview/formField'
import { AuthorizationFormField } from '../sections/Authorization/formField'
import { ServicePlanFormField as ServicePlanSectionFormField } from '../sections/ServicePlan/formField'
import { VisitSchedulingFormField } from '../sections/VisitScheduling/formField'
import { FinalStepsFormField } from '../sections/FinalSteps/formField'

export const ServicePlanFormField = {
  ...AssessmentOverviewFormField,
  ...PatientOverviewFormField,
  ...AuthorizationFormField,
  ...ServicePlanSectionFormField,
  ...VisitSchedulingFormField,
  ...FinalStepsFormField
} as const

export type ServicePlanFormField = (typeof ServicePlanFormField)[keyof typeof ServicePlanFormField]
